export const FIND_OR_CREATE_REQUESTED = 'find_or_create_requested';
export const FIND_OR_CREATE_SUCCESS = 'find_or_create_success';
export const FIND_OR_CREATE_FAILURE = 'find_or_create_failure';

export const STORE_FIND_OR_CREATE_REQUESTED = 'store_find_or_create_requested';
export const STORE_FIND_OR_CREATE_SUCCESS = 'store_find_or_create_success';
export const STORE_FIND_OR_CREATE_FAILURE = 'store_find_or_create_failure';

export const STORE_SETTINGS_FIND_REQUESTED = 'store_settings_find_requested';
export const STORE_SETTINGS_FIND_SUCCESS = 'store_settings_find_success';
export const STORE_SETTINGS_FIND_FAILURE = 'store_settings_find_failure';

export const USER_FIND_OR_CREATE_REQUESTED = 'user_find_or_create_requested';
export const USER_FIND_OR_CREATE_SUCCESS = 'user_find_or_create_success';
export const USER_FIND_OR_CREATE_FAILURE = 'user_find_or_create_failure';

export const ASSIGN_BARCODE_REQUESTED = 'assign_barcode_requested';
export const ASSIGN_BARCODE_SUCCESS = 'assign_barcode_success';
export const ASSIGN_BARCODE_FAILURE = 'assign_barcode_failure';

export const CREATE_BARCODES_REQUESTED = 'create_barcodes_requested';
export const CREATE_BARCODES_SUCCESS = 'create_barcodes_success';
export const CREATE_BARCODES_FAILURE = 'create_barcodes_failure';

export const CREATE_ALL_BARCODES_REQUESTED = 'create_all_barcodes_requested';
export const CREATE_ALL_BARCODES_SUCCESS = 'create_all_barcodes_success';
export const CREATE_ALL_BARCODES_FAILURE = 'create_all_barcodes_failure';

export const UPDATE_INVENTORY_REQUESTED = 'update_inventory_requested';
export const UPDATE_INVENTORY_SUCCESS = 'update_inventory_success';
export const UPDATE_INVENTORY_FAILURE = 'update_inventory_failure';

export const BULK_UPDATE_INVENTORY_REQUESTED = 'bulk_update_inventory_requested';
export const BULK_UPDATE_INVENTORY_SUCCESS = 'bulk_update_inventory_success';
export const BULK_UPDATE_INVENTORY_FAILURE = 'bulk_update_inventory_failure';

export const SEARCH_PRODUCT_REQUESTED = 'search_product_requested';
export const SEARCH_PRODUCT_SUCCESS = 'search_product_success';
export const SEARCH_PRODUCT_FAILURE = 'search_product_failure';

export const REFRESH_BATCHES_REQUESTED = 'refresh_batches_requested';
export const REFRESH_BATCHES_SUCCESS = 'refresh_batches_success';
export const REFRESH_BATCHES_FAILURE = 'refresh_batches_failure';

export const DOWNLOAD_BARCODE_IMAGE_REQUESTED = 'download_barcode_image_requested';
export const DOWNLOAD_BARCODE_IMAGE_SUCCESS = 'download_barcode_image_success';
export const DOWNLOAD_BARCODE_IMAGE_FAILURE = 'download_barcode_image_failure';

export const BARCODE_TEMPLATE_CREATE_REQUESTED = 'barcode_template_create_requested';
export const BARCODE_TEMPLATE_CREATE_SUCCESS = 'barcode_template_create_success';
export const BARCODE_TEMPLATE_CREATE_FAILURE = 'barcode_template_create_failure';

export const BARCODE_TEMPLATE_DELETE_REQUESTED = 'barcode_template_delete_requested';
export const BARCODE_TEMPLATE_DELETE_SUCCESS = 'barcode_template_delete_success';
export const BARCODE_TEMPLATE_DELETE_FAILURE = 'barcode_template_delete_failure';

export const BARCODE_TEMPLATE_INDEX_REQUESTED = 'barcode_template_index_requested';
export const BARCODE_TEMPLATE_INDEX_SUCCESS = 'barcode_template_index_success';
export const BARCODE_TEMPLATE_INDEX_FAILURE = 'barcode_template_index_failure';

export const BARCODE_TEMPLATE_UPDATE_REQUESTED = 'barcode_template_update_requested';
export const BARCODE_TEMPLATE_UPDATE_SUCCESS = 'barcode_template_update_success';
export const BARCODE_TEMPLATE_UPDATE_FAILURE = 'barcode_template_update_failure';

export const BARCODE_TEMPLATE_PREVIEW_REQUESTED = 'barcode_template_preview_requested';
export const BARCODE_TEMPLATE_PREVIEW_SUCCESS = 'barcode_template_preview_success';
export const BARCODE_TEMPLATE_PREVIEW_FAILURE = 'barcode_template_preview_failure';

export const SEARCH_PRODUCT_BARCODE_VALUE_REQUESTED = 'search_product_barcode_value_requested';
export const SEARCH_PRODUCT_BARCODE_VALUE_SUCCESS = 'search_product_barcode_value_success';
export const SEARCH_PRODUCT_BARCODE_VALUE_FAILURE = 'search_product_barcode_value_failure';

// export const REPLACE_PRODUCT_SKU_REQUESTED = 'replace_product_sku_requested';
// export const REPLACE_PRODUCT_SKU_SUCCESS = 'replace_product_sku_success';
// export const REPLACE_PRODUCT_SKU_FAILURE = 'replace_product_sku_failure';

// export const DELETE_PRODUCT_SKU_REQUESTED = 'delete_product_sku_requested';
// export const DELETE_PRODUCT_SKU_SUCCESS = 'delete_product_sku_success';
// export const DELETE_PRODUCT_SKU_FAILURE = 'delete_product_sku_failure';

export const DOWNLOAD_PREVIEW_REQUESTED = 'download_preview_requested'
export const DOWNLOAD_PREVIEW_SUCCESS = 'download_preview_success'
export const DOWNLOAD_PREVIEW_FAILURE = 'download_preview_failure'

export const UPDATE_SELECTED_ITEMS = 'update_selected_items';

export const PRINT_CREATE_REQUESTED = 'print_create_requested';
export const PRINT_CREATE_SUCCESS = 'print_create_success';
export const PRINT_CREATE_FAILURE = 'print_create_failure';

export const ADD_INVENTORY_REQUESTED = 'add_inventory_requested';
export const ADD_INVENTORY_SUCCESS = 'add_inventory_success';
export const ADD_INVENTORY_FAILURE = 'add_inventory_failure';

export const SUBTRACT_INVENTORY_REQUESTED = 'subtract_inventory_requested';
export const SUBTRACT_INVENTORY_SUCCESS = 'subtract_inventory_success';
export const SUBTRACT_INVENTORY_FAILURE = 'subtract_inventory_failure';

export const SET_INVENTORY_REQUESTED = 'set_inventory_requested';
export const SET_INVENTORY_SUCCESS = 'set_inventory_success';
export const SET_INVENTORY_FAILURE = 'set_inventory_failure';

export const SCAN_INVENTORY_REQUESTED = 'scan_inventory_requested';
export const SCAN_INVENTORY_SUCCESS = 'scan_inventory_success';
export const SCAN_INVENTORY_FAILURE = 'scan_inventory_failure';

export const ADD_PLACEHOLDER_ACTION = 'add_placeholder_action';
export const CLEAR_SESSION = 'clear_session';
export const CLEAR_ACTION = 'clear_action';

export const ADD_BULK_PLACEHOLDER_ACTION = 'add_bulk_placeholder_action';
export const CLEAR_BULK_SESSION = 'clear_bulk_session';

export const BULK_INVENTORY_CHANGE_REQUESTED = 'bulk_inventory_change_requested';
export const BULK_INVENTORY_CHANGE_SUCCESS = 'bulk_inventory_change_success';
export const BULK_INVENTORY_CHANGE_FAILURE = 'bulk_inventory_change_failure';

export const BATCH_DETAILS_REQUESTED = 'batch_details_requested';
export const BATCH_DETAILS_SUCCESS = 'batch_details_success';
export const BATCH_DETAILS_FAILURE = 'batch_details_failure';

export const BATCH_INVENTORY_RESULTS_REQUESTED = 'batch_inventory_results_requested';
export const BATCH_INVENTORY_RESULTS_SUCCESS = 'batch_inventory_results_success';
export const BATCH_INVENTORY_RESULTS_FAILURE = 'batch_inventory_results_failure';

export const BATCH_INVENTORY_DOWNLOAD_REQUESTED = 'batch_inventory_download_requested';
export const BATCH_INVENTORY_DOWNLOAD_SUCCESS = 'batch_inventory_download_success';
export const BATCH_INVENTORY_DOWNLOAD_FAILURE = 'batch_inventory_download_failure';

export const LOCATIONS_INDEX_REQUESTED = 'locations_index_requested';
export const LOCATIONS_INDEX_SUCCESS = 'locations_index_success';
export const LOCATIONS_INDEX_FAILURE = 'locations_index_failure';

export const TRANSFER_INVENTORY_REQUESTED = 'transfer_inventory_requested';
export const TRANSFER_INVENTORY_SUCCESS = 'transfer_inventory_success';
export const TRANSFER_INVENTORY_FAILURE = 'transfer_inventory_failure';

export const PAYMENT_REQUESTED = 'payment_requested';
export const PAYMENT_SUCCESS = 'payment_success';
export const PAYMENT_FAILURE = 'payment_failure';

export const PAYMENT_SESSION_REQUESTED = 'payment_session_requested';
export const PAYMENT_SESSION_SUCCESS = 'payment_session_success';
export const PAYMENT_SESSION_FAILURE = 'payment_session_failure';

export const PAYMENT_VERIFICATION_REQUESTED = 'payment_verification_requested';
export const PAYMENT_VERIFICATION_SUCCESS = 'payment_verification_success';
export const PAYMENT_VERIFICATION_FAILURE = 'payment_verification_failure';

export const FIND_BARCODE_VALUE_IMAGE_REQUESTED = 'find_barcode_value_image_requested';
export const FIND_BARCODE_VALUE_IMAGE_SUCCESS = 'find_barcode_value_image_success';

export const GET_FUNGIBLES_REQUESTED = 'get_fungibles_requested';
export const GET_FUNGIBLES_SUCCESS = 'get_fungibles_success';
export const GET_FUNGIBLES_FAILURE = 'get_fungibles_failure';

export const GET_LINE_SETTINGS_REQUESTED = 'get_line_settings_requested';
export const GET_LINE_SETTINGS_SUCCESS = 'get_line_settings_success';
export const GET_LINE_SETTINGS_FAILURE = 'get_line_settings_failure';

export const BARCODE_TEMPLATES_UPGRADE_REQUESTED = 'barcode_templates_upgrade_requested';
export const BARCODE_TEMPLATES_UPGRADE_SUCCESS = 'barcode_templates_upgrade_success';
export const BARCODE_TEMPLATES_UPGRADE_FAILURE = 'barcode_templates_upgrade_failure';

export const CATEGORIES_REQUESTED = 'categories_requested';
export const CATEGORIES_SUCCESS = 'categories_success';
export const CATEGORIES_FAILURE = 'categories_failure';

export const BRANDS_REQUESTED = 'brands_requested';
export const BRANDS_SUCCESS = 'brands_success';
export const BRANDS_FAILURE = 'brands_failure';

export const CREATE_ORDER_ACTION = 'create_order_action';
export const DELETE_ORDER_ACTION = 'delete_order_action';
export const CLEAR_ORDER_ACTIONS = 'clear_order_actions';

export const PUBLISH_ORDER_REQUESTED = 'publish_order_requested';
export const PUBLISH_ORDER_SUCCESS = 'publish_order_success';
export const PUBLISH_ORDER_FAILURE = 'publish_order_failure';

export const READ_ORDER_REQUESTED = 'read_order_requested';
export const READ_ORDER_SUCCESS = 'read_order_success';
export const READ_ORDER_FAILURE = 'read_order_failure';

export const INDEX_FULFILLMENT_STATUSES_REQUESTED = 'index_fulfillment_statuses_requested';
export const INDEX_FULFILLMENT_STATUSES_SUCCESS = 'index_fulfillment_statuses_success';
export const INDEX_FULFILLMENT_STATUSES_FAILURE = 'index_fulfillment_statuses_failure';

export const UPDATE_ORDER_FULFILLMENT_STATUS_REQUESTED = 'update_order_fulfillment_status_requested';
export const UPDATE_ORDER_FULFILLMENT_STATUS_SUCCESS = 'update_order_fulfillment_status_success';
export const UPDATE_ORDER_FULFILLMENT_STATUS_FAILURE = 'update_order_fulfillment_status_failure';

export const UPDATE_LINE_ITEM_QUANTITY_REQUESTED = 'update_line_item_quantity_requested';
export const UPDATE_LINE_ITEM_QUANTITY_SUCCESS = 'update_line_item_quantity_success';
export const UPDATE_LINE_ITEM_QUANTITY_FAILURE = 'update_line_item_quantity_failure';

export const CLEAR_ORDER = 'clear_order';
export const SET_CHECKED_LIST = 'set_checked_list';
export const SET_UNPICKABLE_LIST = 'set_unpickable_list';

export const SETTINGS_REQUESTED = 'settings_requested';
export const SETTINGS_SUCCESS = 'settings_success';
export const SETTINGS_FAILURE = 'settings_failure';

export const SETTINGS_UPDATE_REQUESTED = 'settings_update_requested';
export const SETTINGS_UPDATE_SUCCESS = 'settings_update_success';
export const SETTINGS_UPDATE_FAILURE = 'settings_update_failure';

export const UPLOAD_TOKEN_REQUESTED = 'upload_token_requested';
export const UPLOAD_TOKEN_SUCCESS = 'upload_token_success';

export const LOGO_UPLOAD_REQUESTED = 'logo_upload_requested';
export const LOGO_UPLOAD_SUCCESS = 'logo_upload_success';
export const LOGO_UPLOAD_FAILURE = 'logo_upload_failure';

export const INCOMPLETE_ORDERS_REQUESTED = 'incomplete_orders_requested';
export const INCOMPLETE_ORDERS_SUCCESS = 'incomplete_orders_success';
export const INCOMPLETE_ORDERS_FAILURE = 'incomplete_orders_failure';

export const ORDER_SHIPMENTS_REQUESTED = 'order_shipments_requested';
export const ORDER_SHIPMENTS_SUCCESS = 'order_shipments_success';
export const ORDER_SHIPMENTS_FAILURE = 'order_shipments_failure';

export const WAREHOUSE_RECEIVING_ORDERS_INDEX_REQUESTED = 'warehouse_receiving_orders_requested';
export const WAREHOUSE_RECEIVING_ORDERS_INDEX_SUCCESS = 'warehouse_receiving_orders_success';
export const WAREHOUSE_RECEIVING_ORDERS_INDEX_FAILURE = 'warehouse_receiving_orders_failure';

export const WAREHOUSE_RECEIVING_ORDER_FIND_REQUESTED = 'warehouse_receiving_order_find_requested';
export const WAREHOUSE_RECEIVING_ORDER_FIND_SUCCESS = 'warehouse_receiving_order_find_success';
export const WAREHOUSE_RECEIVING_ORDER_FIND_FAILURE = 'warehouse_receiving_order_find_failure';

export const WAREHOUSE_RECEIVING_ORDER_REMOVE_REQUESTED = 'warehouse_receiving_order_remove_requested';
export const WAREHOUSE_RECEIVING_ORDER_REMOVE_SUCCESS = 'warehouse_receiving_order_remove_success';
export const WAREHOUSE_RECEIVING_ORDER_REMOVE_FAILURE = 'warehouse_receiving_order_remove_failure';


export const SAVE_PICK_ORDER_STATE_REQUESTED = 'save_pick_order_state_requested';
export const SAVE_PICK_ORDER_STATE_SUCCESS = 'save_pick_order_state_success';
export const SAVE_PICK_ORDER_STATE_FAILURE = 'save_pick_order_state_failure';

export const RESTORE_ORDER_PICK_STATE = 'restore_order_pick_state';

export const GET_PRODUCT_CUSTOM_FIELDS_REQUESTED = 'get_product_custom_fields_requested';
export const GET_PRODUCT_CUSTOM_FIELDS_SUCCESS = 'get_product_custom_fields_success';
export const GET_PRODUCT_CUSTOM_FIELDS_FAILURE = 'get_product_custom_fields_failure';

// export const _REQUESTED = '_requested';
// export const _SUCCESS = '_success';
// export const _FAILURE = '_failure';
